var map = {
	"./chart-off.svg": 3777,
	"./gear-off.svg": 3107,
	"./magnifier-off.svg": 2532,
	"./mainStar-off.svg": 5528,
	"./sims-off.svg": 7261,
	"./stars-off.svg": 7734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 639;